import API from "@/helpers/Api";

export default class TypeEquipement {

    id;
    nom;
    description;
    entite;
    categorie;
    enabled = false;
    api = new API();

    constructor() {
        this.id = null;
        this.description = null;
        this.categorie = null;
        this.nom = null;
        this.enabled = false;

    }


  
     

}